import { epoch, utc } from '../util/datetime';
import { toUUID } from '../util/transform';
import { DocType } from './global/Doc.enum';
import type { IRoot } from './Root.interface';

export default class Root implements IRoot {
  docType: DocType;
  id: ?string;
  idOwner: ?string;
  idClone: ?string;
  isActive: boolean;
  timeStamp: number;

  /**
   * Constructor
   * @param {DocType} docType
   * @param {IRoot} data
   */
  constructor(docType: DocType, data?: IRoot) {
    this.docType = docType;
    this.id = toUUID(data?.id);
    this.idOwner = toUUID(data?.idOwner);
    this.idClone = toUUID(data?.idClone);
    this.isActive = data?.isActive === true;
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
